import { AUTH_TOKEN } from '../../constants/localStorage.js';
import '../../constants/colors.js';
import { isAuthTokenExpired } from '../../../context/DynamicContext/helpers.js';

const getAuthToken = () => {
    if (typeof window === 'undefined') {
        return undefined;
    }
    const token = localStorage.getItem(AUTH_TOKEN) || undefined;
    if (!token) {
        return undefined;
    }
    if (isAuthTokenExpired(token)) {
        return undefined;
    }
    return token;
};

export { getAuthToken };
